import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('synchronisation_status'),
    syncAllButtonText: defineMessage('sync_all_1'),
    syncFinishedMessage: defineMessage('companyname_templatenam_ed_from_integrationname'),
};
